// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__kT1y0","line":"Divider_line__3u18O"};